<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bB03fr/images/cover.jpg?1700268119494" alt="This image is the cover for the book Early Railways"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Early Railways
      </h1>
      <p class="bookDescription body article font2">
        <b>History, references, and resources for modeling the earliest decades of British rail travel.</b><br/>  <br/> This is a guide to the earliest period of railway history, from the very beginnings of steam traction at the start of the nineteenth century, up to about 1880. Over these few decades the railways evolved from something that at the start was markedly different, into a scene that any present-day railwayman would recognize. It is a time with much to commend it from a modeler’s point of view. The trains were much shorter and therefore easier to fit into the limited space most of us have available as, correspondingly, were the station layouts, especially at the beginning of the period. Covering infrastructure, locomotives, carriages, and wagons, this is an invaluable resource for those who want to explore the modeling possibilities of nineteenth-century railways.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter Chatham, Stephen Weston
      </h2>
      
      <p class="authorDescription body article">After working as a geologist, Stephen Weston went on to develop his own company, which specialises in the stabilisation of old shallow mine workings and mineshafts. He joined the London & North Western Railway Society and for three years was the Journal Editor. His interest in the London & Birmingham Railway and 0 Gauge modelling resulted in the formation of Parliamentary Trains Ltd., where Stephen is responsible for kit production and marketing.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d6ffc192